import React, { Fragment, useState } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { navigate } from '@reach/router';

import { Loader } from '@squirrellearningltd/go-teacher-components';
import ListCategory from '../../../../components/ListCategory';
import BackLink from '../../../../components/BackLink';
import bookIcon from '../../../../images/book-icon.png';
import plusCircledSVG from '../../../../images/plus-circled.svg';

import { GET_BOOK_TYPES_QUERY } from '../../../../services/pack/graphql';
import { DELETE_TEMPLATE_CATEG_MUTATION } from '../../services/graphql';
import { HIDE_TEMPLATE_CATEG_MUTATION } from '../../services/graphql';
import styles from './PacksHome.module.scss';
import Tabs from '../../../../components/Tabs';
import Tab from '../../../../components/Tab';

const TABS = {
    published: 1,
    hidden: 2,
};

const PacksHome = () => {
    const [selectedTab, setSelectedTab] = useState(TABS.published);
    const { data, error, loading } = useQuery(GET_BOOK_TYPES_QUERY, {
        variables: {
            hidden: selectedTab === TABS.hidden,
        },
    });

    const [deleteTemplateCateg] = useMutation(DELETE_TEMPLATE_CATEG_MUTATION, {
        update: (_, { data }) => {
            if (
                data.deleteBookTemplateCategory.errors &&
                data.deleteBookTemplateCategory.errors.length
            ) {
                alert(data.deleteBookTemplateCategory.errors[0]);
            }
        },
        refetchQueries: [
            { query: GET_BOOK_TYPES_QUERY, variables: { hidden: false } },
            { query: GET_BOOK_TYPES_QUERY, variables: { hidden: true } },
        ],
        awaitRefetchQueries: true,
    });

    const onDeleteCateg = (categ) => {
        let goAhead = window.confirm(
            `Are you sure you want to delete ${categ.name}?`
        );
        if (goAhead) {
            deleteTemplateCateg({
                variables: {
                    bookTemplateCategoryId: categ.id,
                },
            });
        }
    };

 const [hideTemplateCateg] = useMutation(HIDE_TEMPLATE_CATEG_MUTATION, {
    update: (_, { data }) => {
        if (
            data.hideBookTemplateCategory.errors &&
            data.hideBookTemplateCategory.errors.length
        ) {
            alert(data.hideBookTemplateCategory.errors[0]);
        }
    },
    refetchQueries: [
        { query: GET_BOOK_TYPES_QUERY, variables: { hidden: false } },
        { query: GET_BOOK_TYPES_QUERY, variables: { hidden: true } },
    ],
    awaitRefetchQueries: true,
});

const onHideCateg = (categ) => {
    const toggleHide = categ.hidden ? 'show' : 'hide';
    let goAhead = window.confirm(
        `Are you sure you want to ${toggleHide} ${categ.name}?`
    );
    if (goAhead) {
        hideTemplateCateg({
            variables: {
                bookTemplateCategoryId: categ.id,
                hidden: !categ.hidden, // Toggle the current state
            },
        });
    }
};

    const goToSubcategories = (pack) => {
        navigate(`/pack/${pack.id}/subcategories`, {
            state: { pack: pack },
        });
    };

    return (
        <Fragment>
            <div className={styles.sectionHeader}>
                <div className={styles.TitleIconContainer}>
                    <h1 className={styles.HeaderTitle}>Categories</h1>
                    <img
                        width='20'
                        height='20'
                        src={bookIcon}
                        alt='book-icon'
                    />
                </div>
                <BackLink to='/' text='Back' />
            </div>
            <Tabs className={styles.TabsContainer}>
                <Tab
                    selected={selectedTab === TABS.published}
                    onClick={() => setSelectedTab(TABS.published)}
                >
                    Published
                </Tab>
                <Tab
                    selected={selectedTab === TABS.hidden}
                    onClick={() => setSelectedTab(TABS.hidden)}
                >
                    Hidden
                </Tab>
            </Tabs>
            <div>
                {error && <p>{error.message}</p>}
                {loading && <Loader />}
                <div className={styles.writeCategoriesWrapper}>
                    {selectedTab === TABS.published && (
                        <div className={styles.writeCategoryCard}>
                            <img
                                width='40'
                                src={plusCircledSVG}
                                alt='plus-circled.svg'
                                onClick={() => navigate('/pack/new')}
                            />
                        </div>
                    )}
                    {data &&
                        data.bookTemplateCategories.map((pack) => {
                            return (
                                <ListCategory
                                    key={`pack-${pack.id}`}
                                    onClick={() => goToSubcategories(pack)}
                                    onDelete={() => onDeleteCateg(pack)}
                                    onHide={() => onHideCateg(pack)}
                                    pack={pack}
                                />
                            );
                        })}
                </div>
            </div>
        </Fragment>
    );
};

export default PacksHome;
